"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeoutProxy = void 0;
const timeoutError_1 = require("./timeoutError");
const guard_1 = require("../utils/guard");
const utils_1 = require("./utils");
/**
 * A resiliency proxy that checks if a function returns in a given time or throws a timeout error.
 */
class TimeoutProxy {
    /**
     * Initializes a new instance of the @see TimeoutProxy class.
     * @param timeoutMs Timeout in milli seconds within function must succeed or else a timeout error is thrown.
     * @param logger Logger to use.
     */
    constructor(timeoutMs, logger) {
        guard_1.Guard.throwIfNullOrEmpty(timeoutMs, 'timeoutMs');
        guard_1.Guard.throwIfNullOrEmpty(logger, 'logger');
        this.timeoutMs = timeoutMs;
        this.logger = logger;
    }
    /**
     * Executes a function within a resilience proxy.
     * @param func Function to execute within the resilience proxy.
     * @param requestId Request Guid.
     */
    execute(func, requestId) {
        return __awaiter(this, void 0, void 0, function* () {
            let id;
            this.logger.trace(requestId, `Starting Timeout`, null, utils_1.logFormatter);
            return Promise.race([
                func(),
                new Promise((resolve, reject) => {
                    id = setTimeout(() => {
                        const timeoutError = new timeoutError_1.TimeoutError(`Timeout occurred after ${this.timeoutMs}ms`);
                        this.logger.error(requestId, null, timeoutError, utils_1.logFormatter);
                        reject(timeoutError);
                    }, this.timeoutMs);
                }),
            ]).then(v => {
                clearTimeout(id);
                this.logger.trace(requestId, `Timeout successful`, null, utils_1.logFormatter);
                return v;
            }, err => {
                clearTimeout(id);
                this.logger.error(requestId, `Timeout failed`, err, utils_1.logFormatter);
                throw new timeoutError_1.TimeoutError(`Timeout failed`, err);
            });
        });
    }
}
exports.TimeoutProxy = TimeoutProxy;
//# sourceMappingURL=timeoutProxy.js.map